// defines a base module for a Search Results components that uses Search Client
define('score_bootstrap/Components/ContentSearch/SearchResultsBase',[
    "jquery",
    "eventManager",
    "score_bootstrap/Events/SearchResponseEvent",
    "score_bootstrap/Events/SearchRequestChangeEvent",
    "score_bootstrap/Utils/UrlHelper"
], function ($, eventManager, SearchResponseEvent, SearchRequestChangeEvent, urlHelper) {

    function SearchResultsBase(scope, uniqueId, isLazy, refreshEvents, showMessages) {
        var onSearchResponseEvent = this.onSearchResponseEvent.bind(this), page = 0, searchClient;

        Object.defineProperties(this, {
            scope: { enumerable: false, value: scope },
            $scope: { enumerable: false, value: $(scope) },
            $list: { enumerable: false, value: $(".js-search-results", scope) },
            id: { enumerable: true, value: uniqueId },
            isLazy: { enumerable: true, value: Boolean(isLazy) }, // lazy search return nothing for empty queries
            refreshEvents: { enumerable: false, value: refreshEvents || [] },
            showMessages: { enumerable: false, value: showMessages || [] },
            searchClient: {
                enumerable: false,
                get: function () {
                    if (!searchClient) {
                        searchClient = $(".score-search-client", scope).data("ccf_module");
                    }
                    return searchClient;
                }
            },
            // this 'page' property is used by the appendTiles internals only
            page: {
                enumerable: true,
                get: function () { return page; },
                set: function (val) { page = parseInt(val, 10) || 0; }
            },
            tiles: {
                enumerable: false,
                get: function () {
                    return $("li", this.$list);
                }
            }
        });

        // Cannot add lister to Search Client's module because it may not be initialized yet. But the DOM element is definitely there.
        $(".score-search-client", scope).on(SearchResponseEvent.eventName, function (ignore /*event*/, response) {
            onSearchResponseEvent(response);
        });

        function serverError() {
            self.serviceUnavailable(true);
        }

        if (refreshEvents.length) {
            refreshEvents.forEach(function (ev) {
                eventManager.subscribe(SearchResponseEvent.serverError + ":" + ev, serverError);
                eventManager.subscribe(SearchRequestChangeEvent.scrollToTopResults + ":" + ev, this.scrollToTopResults.bind(this));
            }.bind(this));
        }
    }

    SearchResultsBase.prototype.appendTiles = function appendTiles(newTiles) {
        //throw new Error("Not implemented function SearchResultsBase.appendTiles must be overriden");

        if (this.showMessages.length) {
            this.showMessages.forEach(function (ev) {
                eventManager.trigger(ev, this, newTiles);
            }.bind(this));
        }
    };

    SearchResultsBase.prototype.reset = function reset() {
        throw new Error("Not implemented function SearchResultsBase.reset must be overriden");
    };

    SearchResultsBase.prototype.onSearchResponseEvent = function onSearchResponseEvent(searchResponse) {
        if (!this.isLazy || searchResponse.query || this.searchClient.searchRequest.firstActiveFacet) {
            this.showLazySearchMessage(false);
            this.reset();
            this.appendTiles(searchResponse);
        } else {
            this.showLazySearchMessage(true);
            this.canShowMore(false);
            if (this.$scope.hasClass("js-hide-on-load")) {
                this.$scope.removeClass("js-hide-on-load");
            }
        }
    };

    SearchResultsBase.prototype.showMore = function showMore() {
        var searchClient = this.searchClient,
            newPage = this.page + 1;

        urlHelper.setHashValue(window.location, this.id + "page", newPage);
        searchClient.searchRequest.page = newPage;
        searchClient.searchRequest.startPage = newPage;

        searchClient.search().done(this.appendTiles.bind(this));
    };

    SearchResultsBase.howManyTilesPerRow = function howManyTilesPerRow($list) {
        var tilesInRow = 0;
        $list.find("li").each(function () {
            var $this = $(this), $prev = $this.prev();
            if ($prev.length && $this.position().top !== $prev.position().top) {
                return false;
            }

            tilesInRow = tilesInRow + 1;
        });

        return tilesInRow;
    };

    SearchResultsBase.injectPromoTiles = function injectPromoTiles(component, originalQuantity) {
        if (!component.hasOwnProperty("promoTiles")) {
            throw new Error("component.promoTiles must be defined to use static helper SearchResultsBase.injectPromoTiles");
        }

        var newPromoTiles = [];

        component.promoTiles.forEach(function (promoTile) {
            if (promoTile.index <= originalQuantity || promoTile.index > (component.tiles.length + 1)) {
                return;
            }

            var insertElement = $("<li class='promo-tile-li'></li>").append(promoTile.tileHtml);

            if (promoTile.index === 1) {
                $(component.tiles[0]).before(insertElement);
            } else {
                $(component.tiles.get(promoTile.index - 2)).after(insertElement);
            }

            $(".score-promo-tile", insertElement);
            newPromoTiles.push(insertElement[0]);
        });

        return newPromoTiles;
    };

    SearchResultsBase.getLastRowTiles = function getLastRowTiles(component) {
        if (!component.hasOwnProperty("tiles") || !component.hasOwnProperty("tilesPerRow")) {
            throw new Error("component.tiles and component.tilesPerRow must be defined to use static helper SearchResultsBase.getLastRowTiles");
        }

        var tiles = component.tiles.toArray(), tilesPerRow = component.tilesPerRow, mod;

        // When additional tiles are appended via 'show more', we want to run matchHeight on just
        // the new tiles to avoid changing the tiles already on the screen and causing the scroll
        // position to jump. However, if the math of tiles-per-page works out so that the last row
        // of the old tiles ends up with both, old and new, tiles, then the tiles in that row should
        // be included in matchHeight

        // Divides total number of elements by number of tiles-per-row, returning remainder. This is
        // how we figure out which elements are in the last row.
        mod = tiles.length % tilesPerRow;
        return tiles.slice(-1 * (mod || tilesPerRow));
    };

    SearchResultsBase.prototype.scrollToTopResults = function () {
        $("html, body").animate({
            scrollTop: $(this.scope).offset().top
        },
        "slow");
    }

    return SearchResultsBase;
});
